import { memo, useEffect, useState } from 'react'
import Confetti from 'react-confetti'
import { useGameStore } from '@/store/gameStore'

export const ConfettiOverlay = memo(function ConfettiOverlay() {
  const { confettiAt, clearConfetti } = useGameStore()
  const [size, setSize] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const update = () => setSize({ width: window.innerWidth, height: window.innerHeight })
    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  useEffect(() => {
    if (!confettiAt) return
    const t = setTimeout(clearConfetti, 4000)
    return () => clearTimeout(t)
  }, [confettiAt, clearConfetti])

  if (!confettiAt) return null

  return (
    <Confetti
      width={size.width}
      height={size.height}
      numberOfPieces={150}
      recycle={false}
      run={true}
    />
  )
})
